import React from 'react';

import { ButtonBackgroundAndBorder, PlusIcon, ButtonText } from './AddPartnerButton.styled';
import plus from 'assets/icons/plus.svg';

export const AddPartnerButton = ({ onClick }: { onClick: () => void }) => (
  <ButtonBackgroundAndBorder onClick={onClick}>
    <PlusIcon src={plus} alt={'A plus sign to represent adding a partner'} />
    <ButtonText>Add Partner (If Applicable)</ButtonText>
  </ButtonBackgroundAndBorder>
);
